import { Toaster } from 'sonner';
import { useTheme } from '@/features/theme/use-theme';

/** Os avisos no canto seguem o tema: um aviso branco sobre a tela escura é um clarão. */
export function AppToaster() {
  const { resolved } = useTheme();
  return <Toaster position="bottom-right" richColors closeButton theme={resolved} />;
}
